import { Observable, of } from 'rxjs';
import { flatMap, catchError } from 'rxjs/operators';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ServicesApiService } from 'src/app/core/services/api/services-api.service';
import { ServiceSearchResults } from '../models/services/serviceSearchResults';
import { SearchParams } from '../models/searchParams';
import { NgxSpinnerService } from 'ngx-spinner';


@Injectable()
export class ServiceResolver implements Resolve<ServiceSearchResults> {
    constructor(private api: ServicesApiService,
        private spinner: NgxSpinnerService) { }

    resolve(
        route: ActivatedRouteSnapshot,
    ): Observable<ServiceSearchResults> {
        this.spinner.show();
        return this.api.getServicesByLayer(new SearchParams(), 1)
            .pipe(catchError(errors => {
                return of(null);
            }))
            .pipe(flatMap(p => {
                this.spinner.hide();
                return of(p)
            }
            ));
    }
}
